module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-points-bottom-left-e8de872115d6e9ce3ff15928e3bbf609.svg";